import { hasFunctionalConsent } from './cookieConsentStorage';

export function canUseFunctionalStorage() {
  return hasFunctionalConsent();
}

export function getFunctionalItem(key) {
  if (!canUseFunctionalStorage() || typeof window === 'undefined') {
    return null;
  }

  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function setFunctionalItem(key, value) {
  if (!canUseFunctionalStorage() || typeof window === 'undefined') {
    return false;
  }

  try {
    localStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

export function removeFunctionalItem(key) {
  if (!canUseFunctionalStorage() || typeof window === 'undefined') {
    return false;
  }

  try {
    localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}
